/* ******************** NPM ******************** */
// Use following imports only where needed (not globally)
// Bootstrap modules (add as needed)
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import AOS from "aos";
AOS.init();

/* ******************** BASE ******************** */
// Import utilities as needed
import {
    utl_keyboardFocusMode,
    utl_setFooterYear,
    utl_handleModalClose,
    utl_pageId,
    // utl_ehElements,
    // utl_toggleCookiesAlert,
    // utl_anchorScrollOffset,
} from "./base/_utils";

// Call utility functions after imported
utl_keyboardFocusMode();
utl_setFooterYear();
utl_handleModalClose();
// utl_toggleCookiesAlert();
// utl_anchorScrollOffset();
// document.querySelector('.eh-container') && utl_ehElements();

/* ******************** COMPONENTS ******************** */
import navigationInit from "./components/_navigation";
utl_pageId() === "main-index" && navigationInit();

import carouselsInit from "./components/_carousels";
document.querySelector(".carousel") && carouselsInit();

import customInit from "./components/_custom";
customInit();

/* ******************** PAGES ******************** */
// Individual page scripts are added in the header of specific page's index file
